import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AppSection from './components/AppSection';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';
import RankingSection from './components/RankingSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import FeaturesAndFaq from './components/FeaturesAndFaq';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="relative min-h-screen bg-background-50">
      <Header />

      <main>
        <HeroSection />
        <AppSection />
        <ContactSection />
        <AboutSection />
        <IndexSection />
        <RankingSection />
        <TopicsSection />
        <MediaSection />
        <CarouselSection />
        <CommentsSection />
        <CardsSection />
        <UpdatesSection />
        <FeaturesAndFaq />
      </main>

      <Footer />
    </div>
  );
}